(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AmbitoController', AmbitoController);

    AmbitoController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','entity','ClasesAmbitoService' ];

    function AmbitoController ($timeout, $scope, $stateParams, $uibModalInstance,entity,ClasesAmbitoService) {
        var vm = this;
        vm.tiponivel = $stateParams.tiponivel;
        vm.tipomodelo = $stateParams.tipomodelo;
        vm.idins = $stateParams.idins;
        vm.ambito = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cancel = cancel;
        vm.name=null;
        vm.nivelToShow=nivelToShow();
        
        function nivelToShow () {
        	return ClasesAmbitoService.getTipoNivel(vm.tiponivel);
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
//        console.log(vm.ambito);

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ambito.id !== null) {
            	ClasesAmbitoService.update(vm.ambito, onSaveSuccess, onSaveError);
            } else {
            	ClasesAmbitoService.save(vm.ambito, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
